var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "outer-circle",
    cx: 20.5548,
    cy: 20.9416,
    r: 19.1934,
    stroke: "currentColor",
    strokeWidth: 1.53547
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "inner-circle",
    cx: 20.553,
    cy: 20.9416,
    r: 10.7483,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default "/Frontend/static/media/radio-checked.6ec7b307cb063414dc5486393e306aee.svg";
export { ForwardRef as ReactComponent };